module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("device-management-ledger-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "file-modal",
    attrs: {
      "width": "1500px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    class: 'container ' + _vm.pageContainerSize,
    staticStyle: {
      "margin-right": "auto",
      "margin-left": "auto"
    }
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "100px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: " col-xs-5",
    staticStyle: {
      "margin-left": "120px"
    }
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("閉じる")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-428d53e5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/device-management-ledger-modal.vue
// module id = 970
// module chunks = 0